export default __webpack_public_path__ + "static/media/undraw_feeling_proud_qne1.43c1c23a.svg";